import * as React from 'react'
import { ITripDetails } from '../components/ServiceUsers/Interfaces/ITripDetails'
import ServiceUsersReducer from '../components/ServiceUsers/Store/ServiceUsersReducer'

export interface IAppState {
 pastServices:Array<ITripDetails>;
  upComingServices:Array<ITripDetails>;
  nonFilteredServices:Array<ITripDetails> |undefined;
}

export const initialState: IAppState = {
    pastServices:[],
    upComingServices:[],
    nonFilteredServices:[]
}

export interface IServiceUsersContext {
  state: IAppState
  dispatch: React.Dispatch<IAction>
}

const ServiceUsersContext = React.createContext<IServiceUsersContext>({
  state: {
    pastServices:[],
    upComingServices:[],
    nonFilteredServices:[]
  },
  dispatch: () => {}
})

export enum ActionType {
    GET_NON_FILTERED_SERVICES = 'GET_NON_FILTERED_SERVICES',
    GET_UPCOMING_SERVICES = 'GET_UPCOMING_SERVICES',
    GET_PAST_SERVICES = 'GET_PAST_SERVICES'
}

export type IAction = {
  type: ActionType,
  pastServices:Array<ITripDetails> ,
  upComingServices:Array<ITripDetails>,
  nonFilteredServices?:Array<ITripDetails>
}

const ServiceUsersContextProvider: React.FunctionComponent = ({ children }) => {
  const [state, dispatch] = React.useReducer(
    ServiceUsersReducer,
    initialState as IAppState
  )
  const value = { state, dispatch }
  return <ServiceUsersContext.Provider value={value}>{children}</ServiceUsersContext.Provider>
}

export { ServiceUsersContext, ServiceUsersContextProvider }
